import React from "react";

const CopyIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="9"
      y="9"
      width="11"
      height="11"
      rx="2"
      stroke="currentColor"
      strokeWidth="1.6"
    />
    <rect
      x="4"
      y="4"
      width="11"
      height="11"
      rx="2"
      stroke="currentColor"
      strokeWidth="1.6"
    />
  </svg>
);

export default CopyIcon;
